import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../../config/theme';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import CoelhoIcon from '../../../images/coelho.jpg';
import FederalDrawInfo from '../../components/FederalDrawInfo';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '16px',
    backgroundColor: '#F2F2F2',
    border: '1px solid #E3E3E3',
    margin: '12px 0',
    display: 'grid',
    gridTemplateColumns: '96px minmax(0, 1fr) minmax(130px, auto)',
    columnGap: '14px',
    alignItems: 'stretch',
    padding: '12px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '72px minmax(0, 1fr) minmax(95px, auto)',
      columnGap: '10px',
      padding: '10px',
    },
  },
  imageContainer: {
    width: '96px',
    height: '96px',
    borderRadius: '12px',
    backgroundColor: '#DCDCDC',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    [theme.breakpoints.down('xs')]: {
      width: '72px',
      height: '72px',
    },
  },
  details: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '6px',
  },
  rightCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    color: '#1A1A1A',
    lineHeight: 1.3,
    wordBreak: 'break-word',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
    },
  },
  description: {
    margin: 0,
    color: '#4A4A4A',
    fontWeight: 600,
    lineHeight: 1.35,
    '& span': {
      color: '#1A1A1A',
      fontWeight: 700,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.78rem',
    },
  },
  ticketBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#E9F6E9',
    borderRadius: '10px',
    padding: '6px 10px',
    color: '#2D6E2F',
    fontSize: '1rem',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.78rem',
      gap: '6px',
      padding: '4px 8px',
    },
  },
  ticketIcon: {
    fontSize: '1.05rem',
    color: '#2D6E2F',
    fill: '#2D6E2F',
    flexShrink: 0,
    '& path': {
      fill: '#2D6E2F',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85rem',
    },
  },
  ticketNumber: {
    color: '#1A1A1A',
    fontWeight: 700,
    lineHeight: 1,
  },
}));

export default function ShortWinner({ campaign }) {
  const classes = useStyles();
  const toEntity = campaign?.drawn_to_entity;

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <div className={classes.imageContainer}>
          <img src={(!toEntity && campaign?.drawn_customer?.avatar) || CoelhoIcon} />
        </div>
        <div className={classes.infoContainer}>
          {toEntity ? (
            <>
              <Typography variant="h6" className={classes.title}>
                Prêmio da entidade
                &nbsp;
                <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/star.svg" />
              </Typography>
              <Typography variant="body1" className={classes.description}>
                Número sorteado <span>{campaign?.drawn_ticket_number}</span> — venda mínima não atingida
              </Typography>
              <FederalDrawInfo campaign={campaign} />
            </>
          ) : (
            <>
              <Typography variant="h6" className={classes.title}>
                {campaign?.drawn_customer?.name} ({campaign?.drawn_customer?.cpf})
                &nbsp;
                <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/star.svg" />
              </Typography>
              <Typography variant="body1" className={classes.description}>
                Ganhador(a) com o número da sorte <span>{campaign?.drawn_ticket_number}</span>
              </Typography>
              <FederalDrawInfo campaign={campaign} />
            </>
          )}
        </div>
        <div className={classes.rightCol}>
          <span className={classes.ticketBadge}>
            <SvgIcon className={classes.ticketIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"></path>
            </SvgIcon>
            <span className={classes.ticketNumber}>{campaign?.drawn_ticket_number}</span>
          </span>
        </div>
      </div>
    </ThemeProvider>
  )
}